// source: acompanha/customers/v1/customers.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js');
goog.object.extend(proto, acompanha_common_v1_common_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.acompanha.customers.v1.CreateCustomerRequest', null, global);
goog.exportSymbol('proto.acompanha.customers.v1.CreateCustomerResponse', null, global);
goog.exportSymbol('proto.acompanha.customers.v1.Customer', null, global);
goog.exportSymbol('proto.acompanha.customers.v1.CustomerListItem', null, global);
goog.exportSymbol('proto.acompanha.customers.v1.DeleteCustomerRequest', null, global);
goog.exportSymbol('proto.acompanha.customers.v1.GetCustomerRequest', null, global);
goog.exportSymbol('proto.acompanha.customers.v1.GetCustomerResponse', null, global);
goog.exportSymbol('proto.acompanha.customers.v1.ListCustomersRequest', null, global);
goog.exportSymbol('proto.acompanha.customers.v1.ListCustomersResponse', null, global);
goog.exportSymbol('proto.acompanha.customers.v1.UpdateCustomerRequest', null, global);
goog.exportSymbol('proto.acompanha.customers.v1.UpdateCustomerResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.customers.v1.Customer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.customers.v1.Customer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.customers.v1.Customer.displayName = 'proto.acompanha.customers.v1.Customer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.customers.v1.CustomerListItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.customers.v1.CustomerListItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.customers.v1.CustomerListItem.displayName = 'proto.acompanha.customers.v1.CustomerListItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.customers.v1.ListCustomersRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.customers.v1.ListCustomersRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.customers.v1.ListCustomersRequest.displayName = 'proto.acompanha.customers.v1.ListCustomersRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.customers.v1.ListCustomersResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.acompanha.customers.v1.ListCustomersResponse.repeatedFields_, null);
};
goog.inherits(proto.acompanha.customers.v1.ListCustomersResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.customers.v1.ListCustomersResponse.displayName = 'proto.acompanha.customers.v1.ListCustomersResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.customers.v1.GetCustomerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.customers.v1.GetCustomerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.customers.v1.GetCustomerRequest.displayName = 'proto.acompanha.customers.v1.GetCustomerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.customers.v1.GetCustomerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.customers.v1.GetCustomerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.customers.v1.GetCustomerResponse.displayName = 'proto.acompanha.customers.v1.GetCustomerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.customers.v1.CreateCustomerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.customers.v1.CreateCustomerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.customers.v1.CreateCustomerRequest.displayName = 'proto.acompanha.customers.v1.CreateCustomerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.customers.v1.CreateCustomerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.customers.v1.CreateCustomerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.customers.v1.CreateCustomerResponse.displayName = 'proto.acompanha.customers.v1.CreateCustomerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.customers.v1.UpdateCustomerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.customers.v1.UpdateCustomerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.customers.v1.UpdateCustomerRequest.displayName = 'proto.acompanha.customers.v1.UpdateCustomerRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.customers.v1.UpdateCustomerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.customers.v1.UpdateCustomerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.customers.v1.UpdateCustomerResponse.displayName = 'proto.acompanha.customers.v1.UpdateCustomerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.acompanha.customers.v1.DeleteCustomerRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.acompanha.customers.v1.DeleteCustomerRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.acompanha.customers.v1.DeleteCustomerRequest.displayName = 'proto.acompanha.customers.v1.DeleteCustomerRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.customers.v1.Customer.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.customers.v1.Customer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.customers.v1.Customer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.Customer.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
phone: jspb.Message.getFieldWithDefault(msg, 3, ""),
email: jspb.Message.getFieldWithDefault(msg, 4, ""),
document: jspb.Message.getFieldWithDefault(msg, 5, ""),
documentNumber: jspb.Message.getFieldWithDefault(msg, 6, ""),
street: jspb.Message.getFieldWithDefault(msg, 7, ""),
number: jspb.Message.getFieldWithDefault(msg, 8, ""),
complement: jspb.Message.getFieldWithDefault(msg, 9, ""),
neighborhood: jspb.Message.getFieldWithDefault(msg, 10, ""),
city: jspb.Message.getFieldWithDefault(msg, 11, ""),
state: jspb.Message.getFieldWithDefault(msg, 12, ""),
zipCode: jspb.Message.getFieldWithDefault(msg, 13, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
ordersCount: jspb.Message.getFieldWithDefault(msg, 16, 0),
ordersTotalCents: jspb.Message.getFieldWithDefault(msg, 17, 0),
averageTicketCents: jspb.Message.getFieldWithDefault(msg, 18, 0),
lastOrderAt: (f = msg.getLastOrderAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
unpaidOrdersCount: jspb.Message.getFieldWithDefault(msg, 20, 0),
unpaidAmountCents: jspb.Message.getFieldWithDefault(msg, 21, 0),
category: jspb.Message.getFieldWithDefault(msg, 22, ""),
originSalesChannelUuid: jspb.Message.getFieldWithDefault(msg, 23, ""),
originSalesChannelName: jspb.Message.getFieldWithDefault(msg, 24, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.customers.v1.Customer}
 */
proto.acompanha.customers.v1.Customer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.customers.v1.Customer;
  return proto.acompanha.customers.v1.Customer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.customers.v1.Customer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.customers.v1.Customer}
 */
proto.acompanha.customers.v1.Customer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocument(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentNumber(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreet(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumber(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setComplement(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setNeighborhood(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 15:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrdersCount(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrdersTotalCents(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAverageTicketCents(value);
      break;
    case 19:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastOrderAt(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUnpaidOrdersCount(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUnpaidAmountCents(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 23:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginSalesChannelUuid(value);
      break;
    case 24:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginSalesChannelName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.customers.v1.Customer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.customers.v1.Customer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.customers.v1.Customer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.Customer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDocument();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDocumentNumber();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStreet();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getNumber();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getComplement();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getNeighborhood();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getOrdersCount();
  if (f !== 0) {
    writer.writeInt32(
      16,
      f
    );
  }
  f = message.getOrdersTotalCents();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getAverageTicketCents();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getLastOrderAt();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUnpaidOrdersCount();
  if (f !== 0) {
    writer.writeInt32(
      20,
      f
    );
  }
  f = message.getUnpaidAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getOriginSalesChannelUuid();
  if (f.length > 0) {
    writer.writeString(
      23,
      f
    );
  }
  f = message.getOriginSalesChannelName();
  if (f.length > 0) {
    writer.writeString(
      24,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string phone = 3;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string email = 4;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string document = 5;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getDocument = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setDocument = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string document_number = 6;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getDocumentNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setDocumentNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string street = 7;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getStreet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setStreet = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string number = 8;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string complement = 9;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getComplement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setComplement = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string neighborhood = 10;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getNeighborhood = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setNeighborhood = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string city = 11;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string state = 12;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string zip_code = 13;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.customers.v1.Customer.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
*/
proto.acompanha.customers.v1.Customer.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.customers.v1.Customer.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 15;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.customers.v1.Customer.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 15));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
*/
proto.acompanha.customers.v1.Customer.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.customers.v1.Customer.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional int32 orders_count = 16;
 * @return {number}
 */
proto.acompanha.customers.v1.Customer.prototype.getOrdersCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setOrdersCount = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 orders_total_cents = 17;
 * @return {number}
 */
proto.acompanha.customers.v1.Customer.prototype.getOrdersTotalCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setOrdersTotalCents = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 average_ticket_cents = 18;
 * @return {number}
 */
proto.acompanha.customers.v1.Customer.prototype.getAverageTicketCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setAverageTicketCents = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional google.protobuf.Timestamp last_order_at = 19;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.customers.v1.Customer.prototype.getLastOrderAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 19));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
*/
proto.acompanha.customers.v1.Customer.prototype.setLastOrderAt = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.clearLastOrderAt = function() {
  return this.setLastOrderAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.customers.v1.Customer.prototype.hasLastOrderAt = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional int32 unpaid_orders_count = 20;
 * @return {number}
 */
proto.acompanha.customers.v1.Customer.prototype.getUnpaidOrdersCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setUnpaidOrdersCount = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int64 unpaid_amount_cents = 21;
 * @return {number}
 */
proto.acompanha.customers.v1.Customer.prototype.getUnpaidAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setUnpaidAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional string category = 22;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional string origin_sales_channel_uuid = 23;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getOriginSalesChannelUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 23, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setOriginSalesChannelUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 23, value);
};


/**
 * optional string origin_sales_channel_name = 24;
 * @return {string}
 */
proto.acompanha.customers.v1.Customer.prototype.getOriginSalesChannelName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 24, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.Customer} returns this
 */
proto.acompanha.customers.v1.Customer.prototype.setOriginSalesChannelName = function(value) {
  return jspb.Message.setProto3StringField(this, 24, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.customers.v1.CustomerListItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.customers.v1.CustomerListItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.CustomerListItem.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
phone: jspb.Message.getFieldWithDefault(msg, 3, ""),
email: jspb.Message.getFieldWithDefault(msg, 4, ""),
document: jspb.Message.getFieldWithDefault(msg, 5, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
address: jspb.Message.getFieldWithDefault(msg, 7, ""),
addressNumber: jspb.Message.getFieldWithDefault(msg, 8, ""),
addressComplement: jspb.Message.getFieldWithDefault(msg, 9, ""),
neighborhood: jspb.Message.getFieldWithDefault(msg, 10, ""),
city: jspb.Message.getFieldWithDefault(msg, 11, ""),
state: jspb.Message.getFieldWithDefault(msg, 12, ""),
zipCode: jspb.Message.getFieldWithDefault(msg, 13, ""),
ordersCount: jspb.Message.getFieldWithDefault(msg, 14, 0),
ordersTotalCents: jspb.Message.getFieldWithDefault(msg, 15, 0),
averageTicketCents: jspb.Message.getFieldWithDefault(msg, 16, 0),
lastOrderAt: (f = msg.getLastOrderAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
unpaidOrdersCount: jspb.Message.getFieldWithDefault(msg, 18, 0),
unpaidAmountCents: jspb.Message.getFieldWithDefault(msg, 19, 0),
category: jspb.Message.getFieldWithDefault(msg, 20, ""),
originSalesChannelUuid: jspb.Message.getFieldWithDefault(msg, 21, ""),
originSalesChannelName: jspb.Message.getFieldWithDefault(msg, 22, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.customers.v1.CustomerListItem}
 */
proto.acompanha.customers.v1.CustomerListItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.customers.v1.CustomerListItem;
  return proto.acompanha.customers.v1.CustomerListItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.customers.v1.CustomerListItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.customers.v1.CustomerListItem}
 */
proto.acompanha.customers.v1.CustomerListItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocument(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddress(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressNumber(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddressComplement(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setNeighborhood(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOrdersCount(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOrdersTotalCents(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAverageTicketCents(value);
      break;
    case 17:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLastOrderAt(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUnpaidOrdersCount(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUnpaidAmountCents(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginSalesChannelUuid(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginSalesChannelName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.customers.v1.CustomerListItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.customers.v1.CustomerListItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.CustomerListItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDocument();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAddress();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getAddressNumber();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getAddressComplement();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getNeighborhood();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getOrdersCount();
  if (f !== 0) {
    writer.writeInt32(
      14,
      f
    );
  }
  f = message.getOrdersTotalCents();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getAverageTicketCents();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getLastOrderAt();
  if (f != null) {
    writer.writeMessage(
      17,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUnpaidOrdersCount();
  if (f !== 0) {
    writer.writeInt32(
      18,
      f
    );
  }
  f = message.getUnpaidAmountCents();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getOriginSalesChannelUuid();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getOriginSalesChannelName();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string phone = 3;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string email = 4;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string document = 5;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getDocument = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setDocument = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
*/
proto.acompanha.customers.v1.CustomerListItem.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional string address = 7;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string address_number = 8;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getAddressNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setAddressNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string address_complement = 9;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getAddressComplement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setAddressComplement = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string neighborhood = 10;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getNeighborhood = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setNeighborhood = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string city = 11;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string state = 12;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string zip_code = 13;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional int32 orders_count = 14;
 * @return {number}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getOrdersCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setOrdersCount = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 orders_total_cents = 15;
 * @return {number}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getOrdersTotalCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setOrdersTotalCents = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 average_ticket_cents = 16;
 * @return {number}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getAverageTicketCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setAverageTicketCents = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional google.protobuf.Timestamp last_order_at = 17;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getLastOrderAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 17));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
*/
proto.acompanha.customers.v1.CustomerListItem.prototype.setLastOrderAt = function(value) {
  return jspb.Message.setWrapperField(this, 17, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.clearLastOrderAt = function() {
  return this.setLastOrderAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.hasLastOrderAt = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional int32 unpaid_orders_count = 18;
 * @return {number}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getUnpaidOrdersCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setUnpaidOrdersCount = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 unpaid_amount_cents = 19;
 * @return {number}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getUnpaidAmountCents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setUnpaidAmountCents = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional string category = 20;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string origin_sales_channel_uuid = 21;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getOriginSalesChannelUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setOriginSalesChannelUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional string origin_sales_channel_name = 22;
 * @return {string}
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.getOriginSalesChannelName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CustomerListItem} returns this
 */
proto.acompanha.customers.v1.CustomerListItem.prototype.setOriginSalesChannelName = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.customers.v1.ListCustomersRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.customers.v1.ListCustomersRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.customers.v1.ListCustomersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.ListCustomersRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
pagination: (f = msg.getPagination()) && acompanha_common_v1_common_pb.PaginationRequest.toObject(includeInstance, f),
category: jspb.Message.getFieldWithDefault(msg, 2, ""),
sortBy: jspb.Message.getFieldWithDefault(msg, 3, ""),
sortOrder: jspb.Message.getFieldWithDefault(msg, 4, ""),
originSalesChannelUuid: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.customers.v1.ListCustomersRequest}
 */
proto.acompanha.customers.v1.ListCustomersRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.customers.v1.ListCustomersRequest;
  return proto.acompanha.customers.v1.ListCustomersRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.customers.v1.ListCustomersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.customers.v1.ListCustomersRequest}
 */
proto.acompanha.customers.v1.ListCustomersRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new acompanha_common_v1_common_pb.PaginationRequest;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationRequest.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortBy(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSortOrder(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginSalesChannelUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.customers.v1.ListCustomersRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.customers.v1.ListCustomersRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.customers.v1.ListCustomersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.ListCustomersRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      acompanha_common_v1_common_pb.PaginationRequest.serializeBinaryToWriter
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSortBy();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSortOrder();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOriginSalesChannelUuid();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional acompanha.common.v1.PaginationRequest pagination = 1;
 * @return {?proto.acompanha.common.v1.PaginationRequest}
 */
proto.acompanha.customers.v1.ListCustomersRequest.prototype.getPagination = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationRequest} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationRequest, 1));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationRequest|undefined} value
 * @return {!proto.acompanha.customers.v1.ListCustomersRequest} returns this
*/
proto.acompanha.customers.v1.ListCustomersRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.customers.v1.ListCustomersRequest} returns this
 */
proto.acompanha.customers.v1.ListCustomersRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.customers.v1.ListCustomersRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string category = 2;
 * @return {string}
 */
proto.acompanha.customers.v1.ListCustomersRequest.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.ListCustomersRequest} returns this
 */
proto.acompanha.customers.v1.ListCustomersRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string sort_by = 3;
 * @return {string}
 */
proto.acompanha.customers.v1.ListCustomersRequest.prototype.getSortBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.ListCustomersRequest} returns this
 */
proto.acompanha.customers.v1.ListCustomersRequest.prototype.setSortBy = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string sort_order = 4;
 * @return {string}
 */
proto.acompanha.customers.v1.ListCustomersRequest.prototype.getSortOrder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.ListCustomersRequest} returns this
 */
proto.acompanha.customers.v1.ListCustomersRequest.prototype.setSortOrder = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string origin_sales_channel_uuid = 5;
 * @return {string}
 */
proto.acompanha.customers.v1.ListCustomersRequest.prototype.getOriginSalesChannelUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.ListCustomersRequest} returns this
 */
proto.acompanha.customers.v1.ListCustomersRequest.prototype.setOriginSalesChannelUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.acompanha.customers.v1.ListCustomersResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.customers.v1.ListCustomersResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.customers.v1.ListCustomersResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.customers.v1.ListCustomersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.ListCustomersResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
customersList: jspb.Message.toObjectList(msg.getCustomersList(),
    proto.acompanha.customers.v1.CustomerListItem.toObject, includeInstance),
meta: (f = msg.getMeta()) && acompanha_common_v1_common_pb.PaginationMeta.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.customers.v1.ListCustomersResponse}
 */
proto.acompanha.customers.v1.ListCustomersResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.customers.v1.ListCustomersResponse;
  return proto.acompanha.customers.v1.ListCustomersResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.customers.v1.ListCustomersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.customers.v1.ListCustomersResponse}
 */
proto.acompanha.customers.v1.ListCustomersResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.customers.v1.CustomerListItem;
      reader.readMessage(value,proto.acompanha.customers.v1.CustomerListItem.deserializeBinaryFromReader);
      msg.addCustomers(value);
      break;
    case 2:
      var value = new acompanha_common_v1_common_pb.PaginationMeta;
      reader.readMessage(value,acompanha_common_v1_common_pb.PaginationMeta.deserializeBinaryFromReader);
      msg.setMeta(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.customers.v1.ListCustomersResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.customers.v1.ListCustomersResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.customers.v1.ListCustomersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.ListCustomersResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCustomersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.acompanha.customers.v1.CustomerListItem.serializeBinaryToWriter
    );
  }
  f = message.getMeta();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      acompanha_common_v1_common_pb.PaginationMeta.serializeBinaryToWriter
    );
  }
};


/**
 * repeated CustomerListItem customers = 1;
 * @return {!Array<!proto.acompanha.customers.v1.CustomerListItem>}
 */
proto.acompanha.customers.v1.ListCustomersResponse.prototype.getCustomersList = function() {
  return /** @type{!Array<!proto.acompanha.customers.v1.CustomerListItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.acompanha.customers.v1.CustomerListItem, 1));
};


/**
 * @param {!Array<!proto.acompanha.customers.v1.CustomerListItem>} value
 * @return {!proto.acompanha.customers.v1.ListCustomersResponse} returns this
*/
proto.acompanha.customers.v1.ListCustomersResponse.prototype.setCustomersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.acompanha.customers.v1.CustomerListItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.acompanha.customers.v1.CustomerListItem}
 */
proto.acompanha.customers.v1.ListCustomersResponse.prototype.addCustomers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.acompanha.customers.v1.CustomerListItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.acompanha.customers.v1.ListCustomersResponse} returns this
 */
proto.acompanha.customers.v1.ListCustomersResponse.prototype.clearCustomersList = function() {
  return this.setCustomersList([]);
};


/**
 * optional acompanha.common.v1.PaginationMeta meta = 2;
 * @return {?proto.acompanha.common.v1.PaginationMeta}
 */
proto.acompanha.customers.v1.ListCustomersResponse.prototype.getMeta = function() {
  return /** @type{?proto.acompanha.common.v1.PaginationMeta} */ (
    jspb.Message.getWrapperField(this, acompanha_common_v1_common_pb.PaginationMeta, 2));
};


/**
 * @param {?proto.acompanha.common.v1.PaginationMeta|undefined} value
 * @return {!proto.acompanha.customers.v1.ListCustomersResponse} returns this
*/
proto.acompanha.customers.v1.ListCustomersResponse.prototype.setMeta = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.customers.v1.ListCustomersResponse} returns this
 */
proto.acompanha.customers.v1.ListCustomersResponse.prototype.clearMeta = function() {
  return this.setMeta(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.customers.v1.ListCustomersResponse.prototype.hasMeta = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.customers.v1.GetCustomerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.customers.v1.GetCustomerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.customers.v1.GetCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.GetCustomerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.customers.v1.GetCustomerRequest}
 */
proto.acompanha.customers.v1.GetCustomerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.customers.v1.GetCustomerRequest;
  return proto.acompanha.customers.v1.GetCustomerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.customers.v1.GetCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.customers.v1.GetCustomerRequest}
 */
proto.acompanha.customers.v1.GetCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.customers.v1.GetCustomerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.customers.v1.GetCustomerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.customers.v1.GetCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.GetCustomerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.customers.v1.GetCustomerRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.GetCustomerRequest} returns this
 */
proto.acompanha.customers.v1.GetCustomerRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.customers.v1.GetCustomerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.customers.v1.GetCustomerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.customers.v1.GetCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.GetCustomerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.customers.v1.Customer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.customers.v1.GetCustomerResponse}
 */
proto.acompanha.customers.v1.GetCustomerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.customers.v1.GetCustomerResponse;
  return proto.acompanha.customers.v1.GetCustomerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.customers.v1.GetCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.customers.v1.GetCustomerResponse}
 */
proto.acompanha.customers.v1.GetCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.customers.v1.Customer;
      reader.readMessage(value,proto.acompanha.customers.v1.Customer.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.customers.v1.GetCustomerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.customers.v1.GetCustomerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.customers.v1.GetCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.GetCustomerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.customers.v1.Customer.serializeBinaryToWriter
    );
  }
};


/**
 * optional Customer data = 1;
 * @return {?proto.acompanha.customers.v1.Customer}
 */
proto.acompanha.customers.v1.GetCustomerResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.customers.v1.Customer} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.customers.v1.Customer, 1));
};


/**
 * @param {?proto.acompanha.customers.v1.Customer|undefined} value
 * @return {!proto.acompanha.customers.v1.GetCustomerResponse} returns this
*/
proto.acompanha.customers.v1.GetCustomerResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.customers.v1.GetCustomerResponse} returns this
 */
proto.acompanha.customers.v1.GetCustomerResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.customers.v1.GetCustomerResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.customers.v1.CreateCustomerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.customers.v1.CreateCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.CreateCustomerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
name: jspb.Message.getFieldWithDefault(msg, 1, ""),
phone: jspb.Message.getFieldWithDefault(msg, 2, ""),
email: jspb.Message.getFieldWithDefault(msg, 3, ""),
document: jspb.Message.getFieldWithDefault(msg, 4, ""),
documentNumber: jspb.Message.getFieldWithDefault(msg, 5, ""),
street: jspb.Message.getFieldWithDefault(msg, 6, ""),
number: jspb.Message.getFieldWithDefault(msg, 7, ""),
complement: jspb.Message.getFieldWithDefault(msg, 8, ""),
neighborhood: jspb.Message.getFieldWithDefault(msg, 9, ""),
city: jspb.Message.getFieldWithDefault(msg, 10, ""),
state: jspb.Message.getFieldWithDefault(msg, 11, ""),
zipCode: jspb.Message.getFieldWithDefault(msg, 12, ""),
category: jspb.Message.getFieldWithDefault(msg, 13, ""),
originSalesChannelUuid: jspb.Message.getFieldWithDefault(msg, 14, ""),
originSalesChannelName: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.customers.v1.CreateCustomerRequest;
  return proto.acompanha.customers.v1.CreateCustomerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.customers.v1.CreateCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocument(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentNumber(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreet(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumber(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setComplement(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setNeighborhood(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginSalesChannelUuid(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginSalesChannelName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.customers.v1.CreateCustomerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.customers.v1.CreateCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.CreateCustomerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDocument();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDocumentNumber();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStreet();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getNumber();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getComplement();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getNeighborhood();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getOriginSalesChannelUuid();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getOriginSalesChannelName();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string phone = 2;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string email = 3;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string document = 4;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getDocument = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setDocument = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string document_number = 5;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getDocumentNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setDocumentNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string street = 6;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getStreet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setStreet = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string number = 7;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string complement = 8;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getComplement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setComplement = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string neighborhood = 9;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getNeighborhood = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setNeighborhood = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string city = 10;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string state = 11;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string zip_code = 12;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string category = 13;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string origin_sales_channel_uuid = 14;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getOriginSalesChannelUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setOriginSalesChannelUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string origin_sales_channel_name = 15;
 * @return {string}
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.getOriginSalesChannelName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.CreateCustomerRequest.prototype.setOriginSalesChannelName = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.customers.v1.CreateCustomerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.customers.v1.CreateCustomerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.customers.v1.CreateCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.CreateCustomerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.customers.v1.Customer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.customers.v1.CreateCustomerResponse}
 */
proto.acompanha.customers.v1.CreateCustomerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.customers.v1.CreateCustomerResponse;
  return proto.acompanha.customers.v1.CreateCustomerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.customers.v1.CreateCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.customers.v1.CreateCustomerResponse}
 */
proto.acompanha.customers.v1.CreateCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.customers.v1.Customer;
      reader.readMessage(value,proto.acompanha.customers.v1.Customer.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.customers.v1.CreateCustomerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.customers.v1.CreateCustomerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.customers.v1.CreateCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.CreateCustomerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.customers.v1.Customer.serializeBinaryToWriter
    );
  }
};


/**
 * optional Customer data = 1;
 * @return {?proto.acompanha.customers.v1.Customer}
 */
proto.acompanha.customers.v1.CreateCustomerResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.customers.v1.Customer} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.customers.v1.Customer, 1));
};


/**
 * @param {?proto.acompanha.customers.v1.Customer|undefined} value
 * @return {!proto.acompanha.customers.v1.CreateCustomerResponse} returns this
*/
proto.acompanha.customers.v1.CreateCustomerResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.customers.v1.CreateCustomerResponse} returns this
 */
proto.acompanha.customers.v1.CreateCustomerResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.customers.v1.CreateCustomerResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.customers.v1.UpdateCustomerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.customers.v1.UpdateCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, ""),
name: jspb.Message.getFieldWithDefault(msg, 2, ""),
phone: jspb.Message.getFieldWithDefault(msg, 3, ""),
email: jspb.Message.getFieldWithDefault(msg, 4, ""),
document: jspb.Message.getFieldWithDefault(msg, 5, ""),
documentNumber: jspb.Message.getFieldWithDefault(msg, 6, ""),
street: jspb.Message.getFieldWithDefault(msg, 7, ""),
number: jspb.Message.getFieldWithDefault(msg, 8, ""),
complement: jspb.Message.getFieldWithDefault(msg, 9, ""),
neighborhood: jspb.Message.getFieldWithDefault(msg, 10, ""),
city: jspb.Message.getFieldWithDefault(msg, 11, ""),
state: jspb.Message.getFieldWithDefault(msg, 12, ""),
zipCode: jspb.Message.getFieldWithDefault(msg, 13, ""),
category: jspb.Message.getFieldWithDefault(msg, 14, ""),
originSalesChannelUuid: jspb.Message.getFieldWithDefault(msg, 15, ""),
originSalesChannelName: jspb.Message.getFieldWithDefault(msg, 16, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.customers.v1.UpdateCustomerRequest;
  return proto.acompanha.customers.v1.UpdateCustomerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.customers.v1.UpdateCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhone(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocument(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDocumentNumber(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStreet(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setNumber(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setComplement(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setNeighborhood(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginSalesChannelUuid(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setOriginSalesChannelName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.customers.v1.UpdateCustomerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.customers.v1.UpdateCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPhone();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getDocument();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getDocumentNumber();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStreet();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getNumber();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getComplement();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getNeighborhood();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getOriginSalesChannelUuid();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getOriginSalesChannelName();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string phone = 3;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getPhone = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setPhone = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string email = 4;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string document = 5;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getDocument = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setDocument = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string document_number = 6;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getDocumentNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setDocumentNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string street = 7;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getStreet = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setStreet = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string number = 8;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string complement = 9;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getComplement = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setComplement = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string neighborhood = 10;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getNeighborhood = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setNeighborhood = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string city = 11;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string state = 12;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string zip_code = 13;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string category = 14;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string origin_sales_channel_uuid = 15;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getOriginSalesChannelUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setOriginSalesChannelUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string origin_sales_channel_name = 16;
 * @return {string}
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.getOriginSalesChannelName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerRequest} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerRequest.prototype.setOriginSalesChannelName = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.customers.v1.UpdateCustomerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.customers.v1.UpdateCustomerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.customers.v1.UpdateCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.UpdateCustomerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
data: (f = msg.getData()) && proto.acompanha.customers.v1.Customer.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.customers.v1.UpdateCustomerResponse}
 */
proto.acompanha.customers.v1.UpdateCustomerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.customers.v1.UpdateCustomerResponse;
  return proto.acompanha.customers.v1.UpdateCustomerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.customers.v1.UpdateCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.customers.v1.UpdateCustomerResponse}
 */
proto.acompanha.customers.v1.UpdateCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.acompanha.customers.v1.Customer;
      reader.readMessage(value,proto.acompanha.customers.v1.Customer.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.customers.v1.UpdateCustomerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.customers.v1.UpdateCustomerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.customers.v1.UpdateCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.UpdateCustomerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.acompanha.customers.v1.Customer.serializeBinaryToWriter
    );
  }
};


/**
 * optional Customer data = 1;
 * @return {?proto.acompanha.customers.v1.Customer}
 */
proto.acompanha.customers.v1.UpdateCustomerResponse.prototype.getData = function() {
  return /** @type{?proto.acompanha.customers.v1.Customer} */ (
    jspb.Message.getWrapperField(this, proto.acompanha.customers.v1.Customer, 1));
};


/**
 * @param {?proto.acompanha.customers.v1.Customer|undefined} value
 * @return {!proto.acompanha.customers.v1.UpdateCustomerResponse} returns this
*/
proto.acompanha.customers.v1.UpdateCustomerResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.acompanha.customers.v1.UpdateCustomerResponse} returns this
 */
proto.acompanha.customers.v1.UpdateCustomerResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.acompanha.customers.v1.UpdateCustomerResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.acompanha.customers.v1.DeleteCustomerRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.acompanha.customers.v1.DeleteCustomerRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.acompanha.customers.v1.DeleteCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.DeleteCustomerRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
uuid: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.acompanha.customers.v1.DeleteCustomerRequest}
 */
proto.acompanha.customers.v1.DeleteCustomerRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.acompanha.customers.v1.DeleteCustomerRequest;
  return proto.acompanha.customers.v1.DeleteCustomerRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.acompanha.customers.v1.DeleteCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.acompanha.customers.v1.DeleteCustomerRequest}
 */
proto.acompanha.customers.v1.DeleteCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setUuid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.acompanha.customers.v1.DeleteCustomerRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.acompanha.customers.v1.DeleteCustomerRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.acompanha.customers.v1.DeleteCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.acompanha.customers.v1.DeleteCustomerRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUuid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string uuid = 1;
 * @return {string}
 */
proto.acompanha.customers.v1.DeleteCustomerRequest.prototype.getUuid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.acompanha.customers.v1.DeleteCustomerRequest} returns this
 */
proto.acompanha.customers.v1.DeleteCustomerRequest.prototype.setUuid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


goog.object.extend(exports, proto.acompanha.customers.v1);
